import React, { useContext } from 'react';
import Table from '../../../components/common/table/Table';
import { FaTrash } from 'react-icons/fa';
import { MdEdit } from 'react-icons/md';
import CustomerContext from '../../../context/customerContext/CustomerContext';
import CreateNewCustomer from './CreateNewCustomer';
import {
  ModalProvider,
  useModal,
} from '../../../components/common/modal/ModalContext';
import ActionButtons from '../../../components/common/ActionButtons';

const CustomerTable = () => {
  const {
    deleteCustomer,
    getAllCustomer,
    customerData,
    totalElements,
    currentPage,
    setCurrentPage,
    pageSize,
    clearFormData,
    sortBy,
    setSortBy,
    sortDir,
    setSortDir,
    searchQuery,
  } = useContext(CustomerContext);
  const { openModal, closeModal } = useModal();

  const handleOpenModal = (user) => {
    clearFormData();
    openModal(
      <CreateNewCustomer closeModal={closeModal} user={user} />,
      'Update Customer',
    );
  };

  const handleSortChange = ({ field, direction }) => {
    setSortBy(field); // Update the sortBy field
    setSortDir(direction); // Update the sort direction
    getAllCustomer(currentPage, pageSize, searchQuery, field, direction); // Fetch sorted data
  };

  const columns = [
    { header: 'Cust Code', field: 'customerCode' },
    { header: 'Customer Name', field: 'customerName' },
    { header: 'Phone No.', field: 'phone' },
    { header: 'Contact Person', field: 'contactPerson' },
    { header: 'Address', field: 'address' },
    { header: 'Email', field: 'email' },
    { header: 'Avg Purchase', field: 'avgPurchase' },
    {
      header: 'ACTIONS',
      render: (user) => (
        <ActionButtons
          actions={[
            {
              icon: <FaTrash />,
              onClick: () => deleteCustomer(user.id),
              tooltip: 'Delete Customer',
              className: 'text-red-500 pr-5',
            },
            {
              icon: <MdEdit />,
              onClick: () => handleOpenModal(user),
              tooltip: 'Edit Customer',
              className: 'text-gray-500',
            },
          ]}
        />
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        data={customerData}
        totalElements={totalElements}
        pageSize={pageSize}
        currentPage={currentPage}
        onPageChange={(newPage) => setCurrentPage(newPage)}
        onSortChange={handleSortChange} // Pass sorting handler
        sortConfig={{ field: sortBy, direction: sortDir }} // Pass current sorting state
      />
    </>
  );
};

const App = () => (
  <ModalProvider>
    <CustomerTable />
  </ModalProvider>
);

export default App;
